import { createFileRoute } from '@tanstack/react-router'
import { SettingBlacklist } from '@/components/settings-route/blacklist'

export const Route = createFileRoute('/_auth/settings/blacklist')({
  component: SettingBlacklist,
})
